import moment from 'moment-timezone';
import qs from 'qs';
import {
  PROJECT_MAPPINGS_REQUEST,
  PROJECT_MAPPINGS_FAILURE,
  PROJECT_MAPPINGS_SUCCESS,
} from '../constants/actions';
import config from '../../config';
import { getItem, setItem } from '../utils/storage';
import { fetchM } from './fetchM';
import { handleError } from './error';

function projectMappingsRequest() {
  return {
    type: PROJECT_MAPPINGS_REQUEST,
  };
}

function projectMappingsSuccess(data, token = null) {
  return {
    type: PROJECT_MAPPINGS_SUCCESS,
    payload: {
      data,
      token,
    },
  };
}

function projectMappingsError(message) {
  return {
    type: PROJECT_MAPPINGS_FAILURE,
    payload: {
      statusText: message,
    },
  };
}

export function fetchProjectMappings(fresh = true) {
  return (dispatch) => {
    let token = null;
    let reload = false;
    dispatch(projectMappingsRequest());
    if (!fresh) {
      let projectMappingsData = {};
      try {
        projectMappingsData = JSON.parse(getItem(`${config.get('appName')}.projectMappings`)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (
        !projectMappingsData.data ||
        config.get('version') !== projectMappingsData.version ||
        moment().isAfter(moment(projectMappingsData.createdAt).add(1, 'day'))
      ) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectMappingsSuccess(projectMappingsData.data));
        return Promise.resolve();
      }
    }
    const q = Object.assign({
      limit: 0,
    });
    return dispatch(fetchM(`/mappings/projects/?${qs.stringify(q)}`, {
      credentials: 'include',
    }))
      .then((res) => {
        token = res.headers.get('X-Csrf-Token');
        return res.json();
      })
      .then((data) => {
        try {
          setItem(`${config.get('appName')}.projectMappings`, JSON.stringify({
            data,
            createdAt: moment().toDate(),
            version: config.get('version'),
          }));
        } catch (e) {
          Bugsnag.notifyException(e);
        }
        dispatch(projectMappingsSuccess(data, token));
      })
      .catch(err => dispatch(handleError(err, projectMappingsError)));
  };
}



// WEBPACK FOOTER //
// ./src/actions/projectMappings.js